import axios from '@axios'

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {
 
    },
    actions: {
        fetchReprises(ctx, payload) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/vehicules/reprise', { params: payload })
                    .then(response => resolve(response.data))
                    .catch(error => reject(error))
            })
        },
        fetch(ctx, payload) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/vehicules/reprise/'  + payload.reprise_id , { params: payload })
                    .then(response => resolve(response.data))
                    .catch(error => reject(error))
            })
        },
        
    },
}
